
export default function Footer() {
  const handleNavClick = (path: string) => {
    window.REACT_APP_NAVIGATE(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-white overflow-hidden">
      {/* Top accent line */}
      <div className="h-[2px] bg-gradient-to-r from-[#6A1B9A] to-[#BA68C8]"></div>

      {/* Main Content */}
      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12 pt-10 md:pt-14 pb-8 md:pb-12">

        {/* Scroll to Top — positioned inside content flow on mobile */}
        <div className="flex justify-end mb-6 md:mb-0">
          <button
            onClick={scrollToTop}
            className="md:absolute md:top-8 md:right-12 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gradient-to-r from-[#6A1B9A] to-[#BA68C8] rounded-full text-white hover:scale-110 transition-all duration-300 cursor-pointer shadow-lg z-10"
            aria-label="Scroll to top"
          >
            <i className="ri-arrow-up-line text-lg sm:text-xl"></i>
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 lg:gap-16 mb-8 md:mb-10">

          {/* Brand */}
          <div className="col-span-1 sm:col-span-2 lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/455d4b17bb0830d9dc0ba5f28e276371/ed1ea59379778be9f2f707d8cd8be72f.jpeg"
              alt="Mohuba & Partners Inc"
              className="w-[100px] sm:w-[120px] md:w-[140px] h-auto mb-3 md:mb-4"
            />
            <p className="text-sm md:text-base italic text-[#2C2C2C] mb-4 font-serif">
              Your Protector in Law
            </p>
            <div className="flex gap-3">
              {['ri-facebook-fill', 'ri-linkedin-fill', 'ri-twitter-x-line', 'ri-instagram-line'].map((icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center border-2 border-[#6A1B9A] rounded-full text-[#6A1B9A] hover:bg-[#6A1B9A] hover:text-white transition-all duration-200 cursor-pointer"
                >
                  <i className={`${icon} text-base sm:text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h3 className="text-sm sm:text-base md:text-lg font-bold text-[#2C2C2C] mb-4 md:mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { label: 'Home', path: '/home' },
                { label: 'About Us', path: '/about' },
                { label: 'Contact Us', path: '/contact' },
              ].map((item) => (
                <li key={item.path}>
                  <button
                    onClick={() => handleNavClick(item.path)}
                    className="text-xs sm:text-sm text-[#2C2C2C]/80 hover:text-[#BA68C8] transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Contact */}
          <div className="col-span-1">
            <h3 className="text-sm sm:text-base md:text-lg font-bold text-[#2C2C2C] mb-4 md:mb-6">Legal</h3>
            <ul className="space-y-3 mb-6">
              <li>
                <button
                  onClick={() => handleNavClick('/privacy-policy')}
                  className="text-xs sm:text-sm text-[#2C2C2C]/80 hover:text-[#BA68C8] transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick('/terms-of-use')}
                  className="text-xs sm:text-sm text-[#2C2C2C]/80 hover:text-[#BA68C8] transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  Terms of Use
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleNavClick('/legal-disclaimer')}
                  className="text-xs sm:text-sm text-[#2C2C2C]/80 hover:text-[#BA68C8] transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  Legal Disclaimers
                </button>
              </li>
            </ul>
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-[#BA68C8] flex-shrink-0"></i>
                <a href="tel:0795808857" className="text-xs sm:text-sm text-[#2C2C2C]/80 hover:text-[#BA68C8] transition-colors">
                  079 580 8857
                </a>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-mail-line text-[#BA68C8] flex-shrink-0 mt-0.5"></i>
                <a href="mailto:info@mohubapartners.co.za" className="text-xs sm:text-sm text-[#2C2C2C]/80 hover:text-[#BA68C8] transition-colors break-all">
                  info@mohubapartners.co.za
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#F5F5F5] py-4 border-t border-gray-200">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12">
          <p className="text-center text-xs sm:text-sm text-[#666666]">
            © 2025 Mohuba &amp; Partners Inc. All rights reserved. | Polokwane, Limpopo, South Africa
          </p>
        </div>
      </div>
    </footer>
  );
}
